import { cn } from "@/utils";
import { AnimatePresence, Easing, motion } from "motion/react";

export const LimeCollapse = ({
  isOpen,
  children,
  overrides,
  className,
}: {
  isOpen: boolean;
  children: React.ReactNode;
  overrides?: {
    duration: number;
    ease: Easing | [number, number, number, number];
  };
  className?: string;
}) => {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { height: "auto", opacity: 1 },
            collapsed: { height: 0, opacity: 0 },
          }}
          transition={{
            duration: overrides?.duration ?? 0.2,
            ease: overrides?.ease ?? [0.04, 0.62, 0.23, 0.98],
          }}
          className={cn("w-full", className)}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
